import LoginController from './login.controller.js';
import routeConfig from './login.routes';

const LoginComponent = {
	templateUrl: 'components/login/login.html',
	controller: LoginController,
	bindings: {
		$router: '<'
	},
	$routeConfig: routeConfig
};

export default LoginComponent;
